import { render, staticRenderFns } from "./tree-list.vue?vue&type=template&id=95b47e92&"
import script from "./tree-list.vue?vue&type=script&lang=js&"
export * from "./tree-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports